import React from 'react';
export const footerDropContext = React.createContext((el) => el);
export const FooterDropContextProvider = footerDropContext.Provider;
export const headerDropContext = React.createContext((el) => el);
export const HeaderDropContextProvider = headerDropContext.Provider;
